import React, { useState, useEffect } from 'react';
import haukeApiService from '../../services/haukeApi';
import '../../assets/css/profil-admin.css';

const Zertifizierungen = ({ hofId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  // Zertifizierungen nach Rubriken organisiert
  const certificationCategories = [
    {
      title: 'Bio-Verbände',
      icon: '🌿',
      certifications: [
        { id: 'bioland', label: 'Bioland' },
        { id: 'demeter', label: 'Demeter' },
        { id: 'naturland', label: 'Naturland' },
        { id: 'biokreis', label: 'Biokreis' },
        { id: 'biopark', label: 'Biopark' },
        { id: 'biozyklisch_vegan', label: 'Biozyklisch Vegan' },
        { id: 'ecoland', label: 'Ecoland' },
        { id: 'verbund_oekohoefe', label: 'Verbund Ökohöfe' }
      ]
    },
    {
      title: 'Wein & Spezialprodukte',
      icon: '🍷',
      certifications: [
        { id: 'ecovin', label: 'Ecovin' },
        { id: 'gaea', label: 'Gaea' }
      ]
    },
    {
      title: 'EU & Staatliche Siegel',
      icon: '🇪🇺',
      certifications: [
        { id: 'eu_bio', label: 'EU-Bio' },
        { id: 'deutsches_bio_siegel', label: 'Deutsches Bio-Siegel' }
      ]
    },
    {
      title: 'Regionale Siegel',
      icon: '🏞️',
      certifications: [
        { id: 'regional_geprüfte_qualität', label: 'Geprüfte Qualität' },
        { id: 'regional_baden_württemberg', label: 'Qualitätszeichen BW' },
        { id: 'regional_bayern', label: 'Geprüfte Qualität Bayern' },
        { id: 'regional_hessen', label: 'Qualitätszeichen Hessen' }
      ]
    },
    {
      title: 'Tierwohl & Nachhaltigkeit',
      icon: '🐄',
      certifications: [
        { id: 'tierschutz_kontrolliert', label: 'Tierschutz-kontrolliert' },
        { id: 'neuland', label: 'Neuland' },
        { id: 'pro_planet', label: 'PRO PLANET' },
        { id: 'rainforest_alliance', label: 'Rainforest Alliance' }
      ]
    },
    {
      title: 'Faire Produktion',
      icon: '🤝',
      certifications: [
        { id: 'fairtrade', label: 'Fairtrade' },
        { id: 'gepa_fair', label: 'GEPA Fair+' },
        { id: 'hand_in_hand', label: 'Hand in Hand' }
      ]
    }
  ];

  // Flache Liste aller Zertifizierungen für Berechnungen
  const allCertifications = certificationCategories.flatMap(cat => cat.certifications);

  useEffect(() => {
    loadData();
  }, [hofId]);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await haukeApiService.getDirekterzeugerDetails(hofId);
      setData(response.data);
    } catch (err) {
      console.error('Error loading data:', err);
      setError('Fehler beim Laden der Daten');
    } finally {
      setLoading(false);
    }
  };

  const showSuccessToast = (message) => {
    const toast = document.createElement('div');
    toast.className = 'success-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 3000);
  };

  const handleCertificationToggle = (certificationId) => {
    const currentCertifications = data.combine || [];
    const newCertifications = currentCertifications.includes(certificationId)
      ? currentCertifications.filter(c => c !== certificationId)
      : [...currentCertifications, certificationId];
    
    setData({ ...data, combine: newCertifications, combines: newCertifications });
    setHasChanges(true);
  };

  const handleSave = async () => {
    if (!hasChanges) return;

    try {
      setSaving(true);
      const updateData = {
        combine: data.combine || [],
        combines: data.combine || []
      };
      
      await haukeApiService.updateDirekterzeuger(hofId, updateData);
      setHasChanges(false);
      showSuccessToast('Zertifizierungen erfolgreich gespeichert!');
    } catch (err) {
      console.error('Error saving:', err);
      alert('Fehler beim Speichern: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (hasChanges) {
      if (window.confirm('Änderungen verwerfen?')) {
        loadData();
        setHasChanges(false);
      }
    }
  };

  if (loading) return <div className="webling-loading">Daten werden geladen...</div>;
  if (error) return <div className="webling-error">{error}</div>;
  if (!data) return <div className="webling-error">Keine Daten verfügbar</div>;

  const selectedCertifications = data.combine || [];

  return (
    <div className="webling-container">
      <div className="webling-content">
        {certificationCategories.map(category => (
          <div key={category.title} className="form-section">
            <h3>
              <span className="category-icon">{category.icon}</span>
              {category.title}
            </h3>
            <div className="features-grid">
              {category.certifications.map(certification => (
                <label key={certification.id} className="feature-checkbox">
                  <input
                    type="checkbox"
                    checked={selectedCertifications.includes(certification.id)}
                    onChange={() => handleCertificationToggle(certification.id)}
                    disabled={saving}
                  />
                  <span className="checkbox-label">{certification.label}</span>
                </label>
              ))}
            </div>
          </div>
        ))}


      </div>

      <div className="webling-footer">
        <button 
          onClick={handleSave}
          disabled={!hasChanges || saving}
          className="save-button"
        >
          {saving ? 'Speichern...' : 'Speichern'}
        </button>
        <button 
          onClick={handleCancel}
          disabled={saving}
          className="cancel-button"
        >
          Schließen
        </button>
      </div>
    </div>
  );
};

export default Zertifizierungen; 